import initialState from '../../data/ccVerification';
import ActionTypes from '../constants/action-types';

const CcVerificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.UPDATE_CC_VERIFICATION:
            return {
                ...state,
                ...action.payload
            };
        default: return state;
    }
};

export default CcVerificationReducer;